import React, { useState } from 'react';
import Text from '../../../../../Components/Base/Text/Text';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import CaseTypeOrganizationUnitModal from '../OrganizationUnit/CaseTypeOrganizationUnitModal';

// @ts-ignore
import styles from './CaseTypeListHeader.module.scss';
import CaseTypeWizardModal from '../CaseTypeWizard/CaseTypeWizardModal';

interface Props {
	workplaceId: string;
	reloadList: () => void;
	isOnlyOneRoot: boolean;
	openShifts: () => void;
	isControlsEnabled?: boolean;
}
const CaseTypeListHeader: React.FC<Props> = ({
	workplaceId,
	reloadList,
	isOnlyOneRoot,
	openShifts,
	isControlsEnabled = true,
}) => {
	const [isCaseTypeDetailOpen, setIsCaseTypeDetailOpen] = useState(false);
	const [isOrganizationUnitDetailOpen, setIsOrganizationUnitTypeDetailOpen] =
		useState(false);

	const handleCreateCaseType = () => {
		setIsCaseTypeDetailOpen(true);
	};

	const handleCreateOrganizationUnit = () => {
		setIsOrganizationUnitTypeDetailOpen(true);
	};

	const handleOrganizationUnitCreateSuccess = () => {
		setIsOrganizationUnitTypeDetailOpen(false);
		reloadList();
	};

	const handleOnConfirmationClose = () => {
		setIsOrganizationUnitTypeDetailOpen(false);
		reloadList();
	};

	return (
		<div className={styles.wrapper}>
			<Text tx='component.caseType.text1' className={styles.title} />
			{isControlsEnabled && (
				<div className={styles.controls}>
					<Button
						theme={Theme.BLUE}
						title='component.caseType.createNewManagementUnit'
						onClick={handleCreateOrganizationUnit}
					/>
					{isOrganizationUnitDetailOpen && (
						<CaseTypeOrganizationUnitModal
							isOpened
							onClose={handleOnConfirmationClose}
							workplaceId={workplaceId}
							onSuccess={handleOrganizationUnitCreateSuccess}
							isOnlyOneRoot={isOnlyOneRoot}
						/>
					)}
					<Button
						theme={Theme.GREEN}
						title='component.caseType.createNewCaseType'
						onClick={handleCreateCaseType}
					/>
					{isCaseTypeDetailOpen && (
						<CaseTypeWizardModal
							isOpen
							workplaceId={workplaceId}
							isOnlyOneRoot={isOnlyOneRoot}
							onClose={() => setIsCaseTypeDetailOpen(false)}
							onRedirectToShifts={openShifts}
							reloadList={reloadList}
						/>
					)}
				</div>
			)}
		</div>
	);
};

export default CaseTypeListHeader;
